import { makeStyles } from "@material-ui/core";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    backgroundColor: theme.palette.mono.lightGray,
    padding: theme.spacing(2, 4),
    display: "flex",
    alignItems: "center",
  },
  resultsText: {
    fontStyle: "italic",
    fontSize: "12px",
    color: theme.palette.mono.primaryDark,
    paddingRight: theme.spacing(1),
  },
  zoomAllText: {
    "&:hover": {
      background: "none",
    },
    textTransform: "none",
    textDecoration: "underline",
    padding: 0,
    color: theme.palette.colour.primaryBlue,
    minWidth: 0,
  },
  settings: {
    marginLeft: "auto",
    cursor: "pointer",
  },
  infoIcon: {
    marginRight: theme.spacing(1),
  },
}));

export { useStyles };
